module.exports = __webpack_public_path__ + "img/google-play-icon@3x.73b6ade1.png";